export default __webpack_public_path__ + "static/media/polygon.7e177900.webp";